import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SportsBetslipPage } from './sports-betslip';
import { SharedModule } from '../../shared/shared.module';
import { BaselineSharedModule } from 'baseline-lib';

@NgModule({
  declarations: [
    SportsBetslipPage,
  ],
  imports: [
    IonicPageModule.forChild(SportsBetslipPage),
    SharedModule,
    BaselineSharedModule
  ],
})
export class SportsBetslipPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/sports-betslip/sports-betslip.module.ts